var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 65,
    viewBox: "0 0 300 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 68.5V0.953889C4.84715 9.43585 15.533 13.9449 25.072 15.9074C34.8162 17.9122 43.3364 17.254 51.1723 15.4901C57.2093 14.1311 62.8563 12.1105 68.3256 10.1535C69.9389 9.57618 71.5367 9.00444 73.1245 8.45684C80.115 6.04603 86.9332 4.09361 94.1622 4.09361C100.412 4.09361 108.207 5.70058 117.269 8.15631C123.306 9.79224 129.878 11.7969 136.907 13.9408C140.426 15.0142 144.06 16.1225 147.798 17.2369C170.184 23.9108 196.241 30.7793 223.448 31.4998C245.225 32.0766 263.742 28.0878 278.049 22.0518C291.509 16.3728 301.273 8.86749 306.5 1.61702V68.5H-7.5Z",
    fill: "url(#paint0_linear_3104_25035)",
    stroke: "#136773"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3104_25035",
    x1: 149.5,
    y1: 11,
    x2: 149,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136773",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStats);
export default __webpack_public_path__ + "static/media/grayStats.dbcbdd81c11f75aff108f9414756fabf.svg";
export { ForwardRef as ReactComponent };